import { gql } from "lib/apolloClient";

export const getAllBillingTagsQuery = gql`
  query getAllBillingTags($input: TagFilters!) {
    platform {
      allTags(input: $input) {
        id
        key
        value
      }
    }
  }
`;
